import React from "react";
import moment from "moment";

const ESTADO_CONFIG = {
  pendiente: { label: "Pendiente", className: "bg-warning text-dark" },
  programado: { label: "Programado", className: "bg-info" },
  en_proceso: { label: "En proceso", className: "bg-primary" },
  completado: { label: "Completado", className: "bg-success" },
  cancelado: { label: "Cancelado", className: "bg-danger" },
};

const formatDate = (date) => (!date ? "-" : moment(date).format("DD MMM YYYY"));
const formatCurrency = (value) => {
  if (!value && value !== 0) return "-";
  return new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP" }).format(value);
};

const CardSection = ({ icon, title, children }) => (
  <div className="card border-light mb-3">
    <div className="card-header bg-transparent border-bottom py-2">
      <i className={`fas ${icon} text-primary me-2`} />
      <strong className="text-uppercase small text-muted">{title}</strong>
    </div>
    <div className="card-body py-2">{children}</div>
  </div>
);

const FieldRow = ({ label, value, fullWidth }) => (
  <div className={`d-flex justify-content-between py-1 ${fullWidth ? "flex-column" : ""}`}>
    <span className="text-muted">{label}</span>
    <span className={`fw-medium ${fullWidth ? "mt-1" : ""}`}>{value || "-"}</span>
  </div>
);

const MantenimientoDetailsModal = ({ show, onHide, mantenimiento }) => {
  if (!show) return null;

  const estadoConfig = ESTADO_CONFIG[mantenimiento?.estado] || {
    label: mantenimiento?.estado,
    className: "bg-secondary",
  };

  return (
    <>
      <div className="modal fade show" style={{ display: "block", zIndex: 1060 }}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <i className="fas fa-wrench text-primary me-2" />
                Detalles del Mantenimiento
              </h5>
              <button type="button" className="btn-close" onClick={onHide} />
            </div>
            <div className="modal-body">
              <CardSection icon="fa-info-circle" title="Información General">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-muted">Estado</span>
                  <span className={`badge ${estadoConfig.className}`}>{estadoConfig.label}</span>
                </div>
                <FieldRow label="Título" value={mantenimiento?.titulo} />
                <FieldRow label="Descripción" value={mantenimiento?.descripcion} fullWidth />
              </CardSection>

              <CardSection icon="fa-box" title="Activo">
                <div className="d-flex align-items-center">
                  <i className="fas fa-cube text-secondary me-2" />
                  <div>
                    <div className="fw-medium">{mantenimiento?.activo_nombre || "-"}</div>
                    {mantenimiento?.activo?.consecutivo && (
                      <small className="text-muted">{mantenimiento.activo.consecutivo}</small>
                    )}
                  </div>
                </div>
              </CardSection>

              <CardSection icon="fa-calendar-alt" title="Fechas y Costos">
                <div className="row">
                  <div className="col-4">
                    <div className="text-muted small">Fecha</div>
                    <div className="fw-medium">{formatDate(mantenimiento?.fecha_mantenimiento)}</div>
                  </div>
                  <div className="col-4">
                    <div className="text-muted small">Próximo</div>
                    <div className="fw-medium">{formatDate(mantenimiento?.fecha_proximo_mantenimiento)}</div>
                  </div>
                  <div className="col-4">
                    <div className="text-muted small">Costo</div>
                    <div className="fw-medium text-success">{formatCurrency(mantenimiento?.costo_mantenimiento)}</div>
                  </div>
                </div>
              </CardSection>

              <CardSection icon="fa-user" title="Registro">
                <div className="row">
                  <div className="col-6">
                    <div className="text-muted small">Realizado por</div>
                    <div className="fw-medium">{mantenimiento?.realizado_por || "-"}</div>
                  </div>
                  <div className="col-6">
                    <div className="text-muted small">Fecha creación</div>
                    <div className="fw-medium">{formatDate(mantenimiento?.created_at)}</div>
                  </div>
                </div>
              </CardSection>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onHide}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" style={{ zIndex: 1050 }} onClick={onHide} />
    </>
  );
};

export default MantenimientoDetailsModal;
